import { render, staticRenderFns } from "./RestaurantStatus.vue?vue&type=template&id=437924b0"
import script from "./RestaurantStatus.vue?vue&type=script&lang=ts"
export * from "./RestaurantStatus.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports